import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Link, navigate } from "gatsby";
import { Auth } from 'aws-amplify';

import clsx from 'clsx'
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import HomeIcon from '@material-ui/icons/Home';
import StarIcon from '@material-ui/icons/Star';

const drawerWidth = 240;

const WhiteShadowTypography = withStyles({
    root: {
        color: '#FFFFFF',
        textShadow: '2px 1px 3px #000033',
    }
})(Typography);

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    background: 'linear-gradient(to right,  #444464, #eeeeee)',
    boxShadow: '0 1px 20px #000000',
    borderRadius: '0 0 5px 5px'
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: theme.spacing(2),
    color: "#ffffff",
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    ...theme.mixins.toolbar,
    justifyContent: 'space-between',
    background: 'linear-gradient(to left,  #444464, #eeeeee)',
    boxShadow: '0 1px 20px #000000',
    borderRadius: '0 0 5px 5px'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
}))

const Header = ({ siteTitle, uname }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);


  async function signOut() {
    try {
        await Auth.signOut({ global: true });
        navigate("/");
    } catch (error) {
        console.log('error signing out: ', error);
    }
  };

  function handleDrawerOpen() {
    setOpen(true);
  };

  function handleDrawerClose() {
    setOpen(false);
  };

  return(
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" elevation={0} className={clsx(classes.appBar, { [classes.appBarShift]: open, })} >
        <Toolbar style={{ justifyContent: 'space-between' }}>

          <IconButton color="inherit" aria-label="Open menu" onClick={handleDrawerOpen}
            edge="start" className={clsx(classes.menuButton, open && classes.hide)} >
            <MenuIcon />
          </IconButton>

          <Link to="/home"><WhiteShadowTypography variant="h6">

            {siteTitle}

          </WhiteShadowTypography></Link>
          <div style={{ whiteSpace: 'nowrap', textAlign: 'right' }}>

              <Link to="/usermaint">{uname}</Link> <Button variant='outlined' size='small' onClick={signOut}>Sign Out</Button>

           </div>

        </Toolbar>
      </AppBar>

      <Drawer className={classes.drawer} variant="persistent" anchor="left" open={open} classes={{ paper: classes.drawerPaper, }} >
        <div className={classes.drawerHeader}>
            <WhiteShadowTypography variant="h6">

            Main Menu

            </WhiteShadowTypography>
          <IconButton onClick={handleDrawerClose}>
           <ChevronLeftIcon  style={{ color:'#ffffff'}} />
          </IconButton>
        </div>
        <Divider />
        <List>
            <Link to="/" key="home">
              <ListItem button><ListItemIcon><HomeIcon /></ListItemIcon>
              <ListItemText>Home</ListItemText>
              </ListItem>
            </Link>

           <Link to="/chanlistchg" key="chanlistchg">
             <ListItem button><ListItemIcon><StarIcon /></ListItemIcon>
             <ListItemText>Channels</ListItemText>
             </ListItem>
           </Link>

           <Link to="/skuhome" key="skuhome">
             <ListItem button><ListItemIcon><StarIcon /></ListItemIcon>
             <ListItemText>SKU</ListItemText>
             </ListItem>
           </Link>

           <Link to="/rptauto" key="automation">
             <ListItem button><ListItemIcon><StarIcon /></ListItemIcon>
             <ListItemText>Automation</ListItemText>
             </ListItem>
           </Link>
        </List>
      </Drawer>
    </div>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
  uname: PropTypes.node.isRequired,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header

